// Iteration 1.14 — render router. Dispatches to the per-mode renderer.
// The arena pipeline lives in render/arena.js; the lobby in
// render/arena_lobby.js.

import { GameMode, getGameMode } from '../mode/state.js'
import { renderArena, ScannerSize } from './arena.js'
import { renderArenaLobby } from './arena_lobby.js'

export { ScannerSize }

export function render(opts) {
  switch (getGameMode()) {
    case GameMode.ARENA:
      renderArena(opts)
      return
    case GameMode.ARENA_LOBBY:
    default:
      renderArenaLobby(opts)
      return
  }
}
